<template>
  <div>
    <a class='button is-small' v-bind:class="btnCls" v-on:click="onBtnClick" v-if="isBtn">
      <span v-if="labelHtml" v-html="labelHtml"></span>
      <span v-else>{{label}}</span>
    </a>
    <div :class="['quantity-toggle button is-small', fieldCls]" v-else>
      <a @click="decrement()" v-if="!min || quantity > min">
        <span class="icon has-text-grey is-small is-marginless">
          <font-awesome-icon icon="minus" />
        </span>
      </a>
      <div class="field mb-0" >
        <input class="input is-small is-white width-field input-h has-text-centered" type="number" :max="max" :min="min" readonly :value="quantity">
      </div>
      <a @click="increment()" v-if="!max || quantity < max">
        <span class="icon has-text-grey is-small is-marginless">
          <font-awesome-icon icon="plus" />
        </span>
      </a>
    </div>
  </div>
</template>
<script>
import Util from '@/util'

export default {
  name: 'quantityButton',
  props: {
    label: String,
    fieldPlaceHolder: String,
    fieldCls: String,
    btnCls: String,
    max: Number,
    min: Number,
    labelHtml: String
  },
  data () {
    return {
      quantity: 0,
      isBtn: false
    }
  },
  watch: {
    quantity (val) {
      this.$emit('input', val)
      if (val > 0) {
        this.isBtn = false
      } else {
        this.isBtn = true
        this.$emit('removeitem')
      }
    },
    '$attrs.value' (val) {
      if (!val) {
        this.quantity = 0
        return
      }
      this.quantity = val
    }
  },
  methods: {
    onBtnClick () {
      this.isBtn = false
      this.quantity = 1
      this.$emit('quantityfieldactivated')
    },
    increment () {
      this.quantity++
    },
    decrement () {
      this.quantity--
    }
  },
  mounted () {
    this.quantity = 0
    if (this.$attrs.value > 0) {
      this.quantity = Util.cloneObj(this.$attrs.value)
      return
    }
    this.isBtn = true
  }
}
</script>

<style lang="scss" scoped>
  .quantity-toggle {
    display: flex;
    align-items: center;
    width: fit-content;
  }
  .width-field {
    width: 3em;
  }
  .input-h{
    height: 1.5em;
  }
  .mb-0{
    margin-bottom: 0 !important;
  }
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>
